import { render, staticRenderFns } from "./return-management.vue?vue&type=template&id=319c18d4&scoped=true&"
import script from "./return-management.vue?vue&type=script&lang=js&"
export * from "./return-management.vue?vue&type=script&lang=js&"
import style0 from "./return-management.vue?vue&type=style&index=0&id=319c18d4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319c18d4",
  null
  
)

export default component.exports